"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _TicketRecord = _interopRequireDefault(require("customer-data-objects/ticket/TicketRecord"));

var _react = require("react");

var TicketType = _react.PropTypes.instanceOf(_TicketRecord.default);

var _default = TicketType;
exports.default = _default;
module.exports = exports.default;